var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88 21.06L6.7925 14.2675L0 11.18L6.7925 8.09249L9.88 1.29999L12.9675 8.09249L19.76 11.18L12.9675 14.2675L9.88 21.06ZM21.06 24.7L19.5325 21.2875L16.12 19.76L19.5325 18.2L21.06 14.82L22.62 18.2L26 19.76L22.62 21.2875L21.06 24.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicButton);
export default __webpack_public_path__ + "static/media/magic-button.33d54ed778e39c0cd6e5567b70054a9e.svg";
export { ForwardRef as ReactComponent };